module.exports = __webpack_public_path__ + "static/media/emojis_06.a5a27da7.svg";